/**
 * File blog-nav.js.
 * Handles hiding/showing blog nav on desktop.
 * Handles hiding main nav on scroll.
 * Handles adding class to blog nav when sticky.
 */

const siteContent = document.querySelector('.site-content');
const blogNav = document.querySelector('.blog-nav');
const dropdownBtn = document.querySelector('.blog-nav__dropdown-btn');
const dropdownMenu = document.querySelector('.blog-nav__dropdown-menu');
const blogNavOpenBtn = document.querySelector('.blog-nav__btn--open');
const blogNavCloseBtn = document.querySelector('.blog-nav__btn--close');
const blogNavMain = document.querySelector('.blog-nav__main');
const blogNavClosedClass = 'blog-nav--closed';
const blogNavOpenedClass = 'blog-nav--opened';
const siteContentOverlayClass = 'site-content--overlay';
const blogTopBanner = document.querySelector('.top-banner--desktop');
const nonBlogHeader = document.querySelector('.header__content');
let blogTopBannerHeight = 0;

const topBannersDesktopOffset = document.documentElement.style.getPropertyValue('--top-banner-desktop-height') || "0px";

const blogNavObserverOptions = {
  threshold: [1],
  rootMargin: `-${topBannersDesktopOffset} 0px 0px 0px`
};

const mainNavObserverOptions = {
  threshold: buildThresholdList(),
};

const addStickClass = ([e]) => {
  e.target.classList.toggle('blog-nav--sticky', e.intersectionRatio < 1)
}

const stickCta = (entries, observer) => {
  entries.forEach((entry) => {
    const ratio = entry.intersectionRatio;
    const blogNavPaddingTop = 7;
    const mainNavHeight = 66;
    const scrollZeroPos = mainNavHeight - (blogNavPaddingTop/2);
    blogNavMain ? blogNavMain.style.top = -scrollZeroPos * ratio + 'px' : null;
    
    if (ratio < 0.95) {
      blogNav.classList.add('blog-nav--scrolled');
    } else {
      blogNav.classList.remove('blog-nav--scrolled');
    }
  });
}

const blogNavObserver = new IntersectionObserver(addStickClass, blogNavObserverOptions);
const mainNavObserver = new IntersectionObserver(stickCta, mainNavObserverOptions);

function toggleDropdown() {
  dropdownMenu.classList.toggle('blog-nav__dropdown-menu--active');
  siteContent.classList.toggle(siteContentOverlayClass);

  // if site-content has overlay class, add click listener to remove it
  if (siteContent.classList.contains(siteContentOverlayClass)) {
    siteContent.addEventListener('click', toggleDropdown);
  } else {
    siteContent.removeEventListener('click', toggleDropdown);
  }
}

function openBlogNav() {
  blogNav.classList.remove(blogNavClosedClass);
  blogNav.classList.add(blogNavOpenedClass);
}

function closeBlogNav() {
  blogNav.classList.add(blogNavClosedClass);
  blogNav.classList.remove(blogNavOpenedClass);
}

function buildThresholdList() {
  let thresholds = [];
  let numSteps = 20;

  for (let i = 1.0; i <= numSteps; i++) {
    let ratio = i / numSteps;
    thresholds.push(ratio);
  }

  thresholds.push(0);
  return thresholds;
}

// Inits
if (dropdownBtn) dropdownBtn.addEventListener('click', toggleDropdown);
if (blogNavOpenBtn) blogNavOpenBtn.addEventListener('click', openBlogNav);
if (blogNavCloseBtn) blogNavCloseBtn.addEventListener('click', closeBlogNav);
if (blogNav) blogNavObserver.observe(blogNav);
if (nonBlogHeader) mainNavObserver.observe(nonBlogHeader);
